import { render, staticRenderFns } from "./dialogEffect.vue?vue&type=template&id=49187bf2&"
import script from "./dialogEffect.vue?vue&type=script&lang=js&"
export * from "./dialogEffect.vue?vue&type=script&lang=js&"
import style0 from "./dialogEffect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports